import ProgramAdmin from './ProgramAdmin';

export default ProgramAdmin;
